// extracted by mini-css-extract-plugin
export default {"header":"deselectedElementsPanelNew_header__SEwpr","container":"deselectedElementsPanelNew_container__imKW-"};